import { useLocation, useNavigate } from "react-router";
import { useSpaNavigate } from "shared-ui";
import { useCustomerAppConfig } from "undercarriage";

import { CONNECT_APP_ROUTE_PATHS, NAVIGATION_PATHS } from "../../components/constants";
import { getAirOriginPath } from "../../utils/air-origin-path";

/**
 * Returns a function that navigates the customer back to wherever they entered the AIR flow from
 * (home page, Additional Funding tasks, or the in-review screen) based on the current pathname.
 */
export const useAirBackNavigation = () => {
  const { navigate } = useSpaNavigate("FundingApp");
  const routerNavigate = useNavigate();
  const { pathname } = useLocation();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  return () => {
    const airOrigin = getAirOriginPath(pathname);
    switch (airOrigin) {
      case CONNECT_APP_ROUTE_PATHS.ADDITIONAL_FUNDING:
        return navigate(NAVIGATION_PATHS.ADDITIONAL_FUNDING_TASKS);
      case CONNECT_APP_ROUTE_PATHS.HOME:
        return routerNavigate(`/${customerDomain}/home`);
      default:
        return navigate(NAVIGATION_PATHS.ADDITIONAL_INFORMATION_REQUEST);
    }
  };
};
